import { useEffect, useState } from 'react';
import { useField } from 'formik';

import Upload from '../files/Upload';

export default function UploadField({ name, upload, onChange, onUpload, onDelete, ...rest }) {
    const [field, __, helper] = useField(name);
    const [renderCount, setRenderCount] = useState(0);

    // Re-render when field.value is empty
    useEffect(() => {
        if (!field.value || field.value.length === 0) {
            setRenderCount(prevKey => prevKey + 1); // Increment key to force re-render
        }
    }, [field.value]);

    const handleChange = (files, fileIDs) => {
        if (onUpload) {
            onUpload(files);
        }
        if (onChange) {
            onChange(fileIDs);
        }

        helper.setValue(fileIDs);
    };

    const handleDelete = fileIDs => {
        if (onDelete) {
            onDelete(fileIDs);
        }

        helper.setValue(fileIDs);
    };

    return <Upload key={renderCount} {...rest} onUpload={handleChange} onDelete={handleDelete} upload={upload} />;
}
